import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/auth-context';
import { MyQueries } from './MyQueries';
import './UserQueries.css';

export function MyQueriesPage() {
  const { auth, roleLoading } = useAuth();
  const navigate = useNavigate();
  if (roleLoading) return <div className="zs-page"><p role="status" className="uq-gate"><span className="zs-spinner" aria-hidden="true" />Loading support…</p></div>;
  if (Number(auth?.role) === 2) return <Navigate to="/admin/user-queries" replace />;
  return <MyQueries onCreate={() => navigate('/raise-query')} />;
}
